// src/components/Paywall.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SubscribeButton from "./SubscribeButton";

export default function Paywall({ chapterNumber }) {
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.pathname || `/chapter-${chapterNumber}`;

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="max-w-xl mx-auto p-6 rounded-2xl border shadow-sm text-center bg-white/70 backdrop-blur">
        <h2 className="text-2xl font-bold">Premium Chapter Locked</h2>
        <p className="mt-2 text-gray-700">
          Chapters 1–3 are free. You’re trying to open <b>Chapter {chapterNumber}</b>.
          Subscribe to unlock Chapters 4–10 and finish the Treble Town adventure!
        </p>

        <ul className="mt-4 text-left text-sm text-gray-700 list-disc list-inside">
          <li>Full access to Chapters 4–10</li>
          <li>New melodies & story art</li>
          <li>Rewards, badges & certificate</li>
        </ul>

        {/* Inline checkout that returns you to the same chapter */}
        <div className="mt-6">
          <SubscribeButton
            onSuccess={() => {
              // After payment, reload/return to this page (now unlocked)
              navigate(redirect, { replace: true });
            }}
          />
        </div>

        <p className="mt-3 text-xs text-gray-500">Annual subscription • One-time payment</p>

        {/* Or use the dedicated page (same redirect) */}
        <div className="mt-4">
          <button
            onClick={() => navigate(`/subscribe?redirect=${encodeURIComponent(redirect)}`)}
            className="text-sm text-indigo-700 hover:underline"
          >
            Prefer the full Subscribe page →
          </button>
        </div>
      </div>
    </div>
  );
}
